import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";

interface VideoCardProps {
  video: VideoItem;
  showDesc?: boolean;
}

export default function VideoCard({ video, showDesc = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors animate-fade-up"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 高清视频封面`}
          title={`${video.title} 高清视频在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent opacity-70 group-hover:opacity-90 transition-opacity"></div>

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-white text-xs font-medium">
          {video.categoryLabel}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-accent-500 text-white text-xs font-semibold flex items-center gap-1">
          <i className="ri-star-fill text-[10px]"></i>
          {video.rating}
        </span>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-12 h-12 rounded-full bg-white/25 backdrop-blur flex items-center justify-center text-white">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <p className="text-xs text-white/85 flex items-center gap-2">
            <span>{video.year}</span>
            <span className="w-1 h-1 rounded-full bg-white/50"></span>
            <span className="truncate">{video.duration}</span>
          </p>
        </div>
      </div>

      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
          {video.region} · {video.tags.slice(0, 2).join(" / ")}
        </p>
        {showDesc && (
          <p className="mt-2 text-xs text-foreground-600 leading-relaxed line-clamp-2">{video.description}</p>
        )}
      </div>
    </Link>
  );
}